/**
 * EmptyState — bloc d'absence (liste vide, onglet pas encore implemente).
 *
 *   <EmptyState
 *     icon={ImageIcon}
 *     title="Aucune œuvre pour le moment"
 *     description="Ajoutez votre premiere œuvre pour commencer."
 *     action={<Button variant="primary">Nouvelle œuvre</Button>}
 *   />
 *
 *   <EmptyState
 *     title="Bientôt disponible"
 *     description="Cet onglet sera activé au sprint S3."
 *     variant="muted"
 *   />
 */

import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import './EmptyState.css'

interface EmptyStateProps {
  icon?: LucideIcon
  title: string
  description?: ReactNode
  action?: ReactNode
  /** `default` cadre dur (encre) · `muted` papier subtle, pour onglets pas encore livres. */
  variant?: 'default' | 'muted'
  className?: string
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  variant = 'default',
  className,
}: EmptyStateProps) {
  const classes = ['empty-state', variant === 'muted' && 'empty-state-muted', className]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes} role="status">
      {Icon && (
        <span className="empty-state-icon" aria-hidden="true">
          <Icon size={28} />
        </span>
      )}
      <h2 className="empty-state-title">{title}</h2>
      {description && <p className="empty-state-description">{description}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  )
}
